module.exports = __webpack_public_path__ + "static/img/other.579c330.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/other.png
// module id = 9Oit
// module chunks = 0